import React from 'react'

import { ButtonPropsType } from '@icontainers/design-system/dist/molecules/Button'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

import { StyledButton } from './Button.styled'

type ButtonProps = ButtonPropsType & { mode?: ThemeModeType }

export const Button = (props: ButtonProps): JSX.Element => {
    const { children, colorStyle = 'primary', mode, ...rest } = props

    return (
        <StyledButton colorStyle={colorStyle} $mode={mode} {...rest}>
            {children}
        </StyledButton>
    )
}
